<template>
  <div>
    <el-button class="margin-top margin-left" size="mini" @click="saveWord()">
      保存
    </el-button>
    <div>
      <el-input
        class="margin-top margin-left"
        v-model="sensitiveWord"
        type="textarea"
        :autosize="{ minRows: 2, maxRows: 30 }"
        style="width: 70%"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "SmsSensitiveWord",
  data() {
    return {
      sensitiveWord: "",
    };
  },
  mounted() {
    this.getWord();
  },
  methods: {
    getWord() {
      this.$myhttp
        .post(
          "admin/Sms/getSensitiveWord",
          {},
          {
            "Content-Type": "application/x-www-form-urlencoded",
          }
        )
        .then((res) => {
          // 异步执行成功后
          if (res.data.code == 200) {
            this.sensitiveWord = res.data.data;
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
    saveWord() {
      this.$myhttp
        .post(
          "admin/Sms/saveSensitiveWord",
          { sensitiveWord: this.sensitiveWord },
          {
            "Content-Type": "application/x-www-form-urlencoded",
          }
        )
        .then((res) => {
          // 异步执行成功后
          if (res.data.code == 200) {
            this.$message.success(res.data.msg);
            this.getWord();
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err.message);
        });
    },
  },
};
</script>

<style>
.margin-top {
  margin-top: 10px;
}
.margin-left {
  margin-left: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/Admin/Butler/SmsSensitiveWord.vue